import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface EdgeDeviceDto {
  edgeDeviceId: string;
  edgeDeviceFriendlyName?: string;
  organizationId?: string;
  provisioned: boolean;
  ipAddress?: string;
  macAddress?: string;
  deviceType?: string;
  connectionState?: 'Connected' | 'Disconnected' | 'UNKNOWN' | string;
  connectionStateUpdatedTime?: string;
  lastOnlineTime?: string | null;
  lastOfflineTime?: string | null;
}

@Injectable({ providedIn: 'root' })
export class EdgeDeviceService {
  private readonly baseUrl = `${environment.apiUrl.iotDeviceMgmtService}`;

  constructor(private http: HttpClient) {}

  /**
   * GET /devicemanagement/inventory/edge-devices/available
   * Returns available Edge Devices; optionally include currentDeploymentId to include bound devices when editing.
   * 200 => list, 404 => treat as empty, other errors bubble up so UI can toast.
   */
  getAvailableEdgeDevices(currentDeploymentId?: string): Observable<EdgeDeviceDto[]> {
    let params = new HttpParams();
    if (currentDeploymentId) {
      params = params.set('currentDeploymentId', currentDeploymentId);
    }
    const url = `${this.baseUrl}/edge-devices/available`;
    return this.http.get<EdgeDeviceDto[]>(url, { params }).pipe(
      catchError(err => {
        if (err?.status === 404) {
          return of([]);
        }
        throw err;
      })
    );
  }
}
